import { render, staticRenderFns } from "./NewPagination.vue?vue&type=template&id=ad8cf522&"
import script from "./NewPagination.vue?vue&type=script&lang=ts&"
export * from "./NewPagination.vue?vue&type=script&lang=ts&"
import style0 from "./NewPagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports